import { getViewsByParent } from '../BaseTabsRouting/utils';

import Grants from '../Authorization/Grants';
import { Header } from '../BaseTabsRouting/BaseTabsRouting';
import { ApiAccounts } from './ApiAccounts/ApiAccounts';
import GrantsModules from './GrantsModules/GrantsModules';
import Accounts from './Accounts/Accounts';

export enum MenusOptions {
  GROUPS = 'groups',
  ACCOUNTS = 'accounts',
  MODULES = 'modules',
  API_ACCOUNTS = 'api_accounts'
}

export const grantsViews = [
  {
    id: 200,
    name: 'GROUPS',
    Component: Grants,
    parent: MenusOptions.GROUPS
  },
  {
    id: 220,
    name: 'ACCOUNTS',
    Component: Accounts,
    parent: MenusOptions.ACCOUNTS
  },
  {
    id: 240,
    name: 'MODULES',
    Component: GrantsModules,
    parent: MenusOptions.MODULES
  },
  {
    id: 260,
    name: 'API_ACCOUNTS',
    Component: ApiAccounts,
    parent: MenusOptions.API_ACCOUNTS
  }
];

export const grantsHeaders: Header[] = [
  {
    subHeaderName: MenusOptions.GROUPS,
    tabs: getViewsByParent<MenusOptions>(grantsViews, MenusOptions.GROUPS)
  },
  {
    subHeaderName: MenusOptions.ACCOUNTS,
    tabs: getViewsByParent<MenusOptions>(grantsViews, MenusOptions.ACCOUNTS)
  },
  {
    subHeaderName: MenusOptions.MODULES,
    tabs: getViewsByParent<MenusOptions>(grantsViews, MenusOptions.MODULES)
  },
  {
    subHeaderName: MenusOptions.API_ACCOUNTS,
    tabs: getViewsByParent<MenusOptions>(grantsViews, MenusOptions.API_ACCOUNTS)
  }
];
